import { users } from '@/modules/users/mock/usersSeeds'

const integrations = [
  { id: 1, name: 'fieldview' },
  { id: 2, name: 'google_calendar' },
  { id: 3, name: 'leaf_agriculture' },
]

const userIntegrations = [
  {
    user_id: users[0].id,
    integrations: [
      { id: integrations[0].id, name: integrations[0].name, is_active: true },
      { id: integrations[1].id, name: integrations[1].name, is_active: true },
      { id: integrations[2].id, name: integrations[2].name, is_active: false },
    ],
  },
  {
    user_id: users[1].id,
    integrations: [],
  },
  {
    user_id: users[2].id,
    integrations: [
      { id: integrations[1].id, name: integrations[1].name, is_active: true },
    ],
  },
  {
    user_id: users[3].id,
    integrations: [
      { id: integrations[0].id, name: integrations[0].name, is_active: true },
    ],
  },
  {
    user_id: users[4].id,
    integrations: [
      { id: integrations[0].id, name: integrations[0].name, is_active: true },
      { id: integrations[1].id, name: integrations[1].name, is_active: true },
    ],
  },
  {
    user_id: users[5].id,
    integrations: [
      { id: integrations[0].id, name: integrations[0].name, is_active: true },
      { id: integrations[1].id, name: integrations[1].name, is_active: true },
    ],
  },
]

export { integrations, userIntegrations }
